<template>
  <div>
    <a-modal v-model="visible" :width="800" title="发起数据修正申请" :ok-button-props="{ props: { loading: loading } }" @cancel="onClose('cancel')" @ok="onSubmit">
      <a-form-model ref="form" :rules="rules" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="团队" prop="team" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <a-select v-model="form.team" style="width: 100%" @change="handleChange">
                <a-select-option v-for="(record, index) in dataSource" :key="index" :value="index"> {{ record.team_info.team_name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="类型" prop="source_type" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
              <a-select v-model="form.source_type" style="width: 100%" @change="handleChange">
                <a-select-option value="requirement"> 需求 </a-select-option>
                <a-select-option value="issue"> 缺陷 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>

        <template v-if="form.source_type !== 'issue'">
          <a-form-model-item label="需求" prop="source">
            <a-select v-model="form.source" label-in-value style="width: 100%">
              <a-select-option v-for="item in storyData" :key="item.key" :value="item.key">{{ `[PR-${item.key}] ${item.label}` }} </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="完成时间" prop="completed_time">
            <a-date-picker v-model="form.completed_time" show-time placeholder="完成时间" style="width: 100%" value-format="YYYY-MM-DD HH:mm:ss" @change="onChange('completed_time')" />
          </a-form-model-item>
        </template>
        <template v-else>
          <a-form-model-item label="缺陷" prop="source">
            <a-select v-model="form.source" label-in-value style="width: 100%">
              <a-select-option v-for="item in issueData" :key="item.key" :value="item.key"> {{ `[BG-${item.key}] ${item.label}` }} </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="解决时间" prop="resolved_time">
            <a-date-picker v-model="form.resolved_time" show-time placeholder="完成时间" style="width: 100%" value-format="YYYY-MM-DD HH:mm:ss" @change="onChange('resolved_time')" />
          </a-form-model-item>
        </template>
        <a-form-model-item label="备注信息">
          <a-input v-model="form.description" type="textarea" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ offset: 4 }">
          <a-button type="primary" icon="plus" @click="onAdd"> 加入处理清单 </a-button>
        </a-form-model-item>
        <a-table size="small" :pagination="false" :columns="columns" row-key="id" :data-source="correctionList">
          <template slot="customId" slot-scope="text, record"> {{ `${record.source_type === 'requirement' ? 'PR' : 'BG'}-${record.id}` }} </template>
          <template slot="customTitle" slot-scope="text, record">
            <a>{{ record.title }}</a>
          </template>
          <template slot="customTime" slot-scope="text, record">{{ record.source_type === 'requirement' ? record.completed_time : record.resolved_time }}</template>
        </a-table>
      </a-form-model>
    </a-modal>
    <a-button v-tc="{ name: '发起申请' }" type="primary" class="send-button" icon="form" @click="onApply"> 发起申请 </a-button>
  </div>
</template>
<script>
import { dataCorrectionApply } from '@/api/data/noticeboard';
const columns = [
  {
    title: 'ID',
    width: 80,
    align: 'center',
    scopedSlots: { customRender: 'customId' }
  },
  {
    title: '标题',
    ellipsis: true,
    width: 280,
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    title: '完成/解决时间',
    width: 180,
    scopedSlots: { customRender: 'customTime' }
  },
  {
    title: '备注',
    ellipsis: true,
    dataIndex: 'description',
    key: 'description'
  }
];
export default {
  props: {
    dataSource: {
      type: [Array, String],
      default: []
    },
    sourceId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      loading: false,
      visible: false,
      storyData: [],
      issueData: [],
      form: {
        team: null,
        source_type: 'requirement',
        source: {},
        resolved_time: null,
        completed_time: null,
        description: null
      },
      correctionList: [],
      rules: {
        source_type: [{ required: true, message: '类型不能为空', trigger: 'blur' }],
        team: [{ required: true, message: '团队不能为空', trigger: 'blur' }],
        source: [{ required: true, message: '需求不能为空', trigger: 'blur' }],
        completed_time: [{ required: true, message: '完成时间不能为空', trigger: 'blur' }],
        resolved_time: [{ required: true, message: '解决时间不能为空', trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleChange() {
      this.form.source_id = null;
      this.form.completed_time = null;
      if (this.form.source_type === 'requirement' && this.form.team) {
        this.storyData = [];
        const versions = this.dataSource[this.form.team].version.versions;
        versions.forEach(items => {
          items.incomplete_requirements.forEach(item => {
            this.storyData.push({ key: item.id, label: item.title });
          });
        });
      } else if (this.form.source_type === 'issue' && this.form.team) {
        this.issueData = this.dataSource[this.form.team].issue.issues.map(item => {
          return { key: item.id, label: item.title };
        });
      }
    },
    onChange(item) {
      this.$refs.form.validateField([item]);
    },
    onAdd() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.correctionList.push({
            id: this.form.source.key,
            source_type: this.form.source_type,
            title: this.form.source.label,
            completed_time: this.form.completed_time,
            resolved_time: this.form.resolved_time,
            description: this.form.description
          });
          this.form = {
            ...this.form,
            source: {},
            completed_time: null,
            resolved_time: null,
            description: null
          };
        }
      });
    },
    onApply() {
      this.visible = true;
      this.form = {
        team: null,
        source_type: 'requirement',
        source: {},
        resolved_time: null,
        completed_time: null,
        description: null
      };
    },
    onSubmit() {
      if (this.correctionList.length > 0) {
        this.loading = true;
        dataCorrectionApply({ noticeboard_id: this.sourceId, correction_list: this.correctionList })
          .then(() => {
            this.loading = false;
            this.onClose('submit');
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$message.warning('数据修复项不能为空');
      }
    },
    onClose(type) {
      this.$emit('close', type);
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.send-button {
  margin-bottom: 12px;
}
</style>
